import React, { useState } from "react";
import axios from "axios";
import { getToken, base_url } from "../../config/config";

const AddSkills = ({ onSkillAdded }) => {
  const [Skill, setSkill] = useState({
    name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSkill({ ...Skill, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${base_url}/v1/createSkill`, Skill);
      console.log("Skill added:", response.data);
      setSkill({ name: "" });
      onSkillAdded(); // Close the modal on successful submission
    } catch (error) {
      console.error("Error adding Skill:", error);
    }
  };

  return (
    <div>
      <h2>Add Skill</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input
            type='text'
            name='name'
            value={Skill.name}
            onChange={handleChange}
            required
          />
        </div>
        <button type='submit'>Add Skill</button>
      </form>
    </div>
  );
};

export default AddSkills;
